module.exports = __webpack_public_path__ + "img/mangrove.25eb8235.svg";